import React from 'react';
import { Outlet } from 'react-router-dom';
import Navigation from './landing/Navigation';
import Box from '@mui/material/Box';

const PublicLayout = () => (
  <Box sx={{ bgcolor: '#fff' }}>
    <Navigation />
    <Outlet />
  </Box>
);

export default PublicLayout;
